getMultiplePmSections